import styled from "styled-components";

export const ScreenshotContainer = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #e3e3e3;
`;
